/**
 * 展立性能页 UI 映射（办公/电竞/狂暴）。
 * 勿依赖 main-app：本文件经 ZhanliPerformanceModeCard 会被 shared-components 引用。
 * 固件 normalize 规则在 SDK `performanceMode.ts`。
 */

/** 协议 mode=4（20K FPS / 超频），与 SDK SENSOR_MODE.CORDED_20KHZ 一致 */
export const ZHANLI_SENSOR_MODE_20K_FPS = 4;

export const ZHANLI_PERFORMANCE_MODES = [
  { value: 1, activeValues: [1] },
  { value: 2, activeValues: [2] },
  { value: 3, activeValues: [3, 5, 6] },
] as const;

export type ZhanliPerformanceModeUi = 1 | 2 | 3;

/** 高回报档：切回办公/电竞时需连带降到 1K */
export function isHighReportRateHz(hz: number): boolean {
  return hz >= 2000;
}
